import Marquee from "react-fast-marquee";

const words = [
  "Casa", "Pulizia", "Benessere", "Cura personale", "Vestiario",
  "Viaggio", "Mobilità", "Pet essential", "Smart working", "Ufficio",
];

export const BrandMarquee = () => (
  <section className="border-y border-ink/10 bg-panel py-6 md:py-8">
    <Marquee speed={40} gradient={false} autoFill>
      {words.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="px-8 font-serif text-4xl font-light italic text-ink md:text-6xl">
            {w}
          </span>
          <span className="h-2 w-2 rounded-full bg-electric" />
        </div>
      ))}
    </Marquee>
  </section>
);
